<template>
  <div class="py-12">
    <v-row no-gutters align="center" justify="center">
      <v-col class="text-left" cols="12" sm="12" md="8">
        <v-form ref="form" lazy-validation>
          <h1 class="display-1 font-weight-bold">Fazer login</h1>
          <br/>
          <div class="form-input-group">
            <v-text-field
              id="email"
              color="secondary"
              background-color="white"
              light
              v-model="email"
              :rules="[emailRules]"
              prepend-inner-icon="far fa-envelope"
              :append-icon="emailRules === true ? 'done' : ''"
              outlined
              required
            />
            <label for="email">E-mail</label>
          </div>
          <div class="form-input-group">
            <v-text-field
              class="mb-n4"
              id="password"
              color="secondary"
              background-color="white"
              light
              v-model="password"
              :rules="[passwordRules]"
              outlined
              required
              prepend-inner-icon="mdi-lock"
              :append-icon="passwordRules === true? 'done' : ''"
              :type="showPassword ? 'text' : 'password'"
            />
             <label for="password">Senha</label>
          </div>
          <v-checkbox class="mt-1 check-form" color="secondary" v-model="showPassword" label="Mostrar senha" />

          <v-row no-gutters class="ml-0 mt-4" align="center">
            <v-col cols="4" md="3">
              <v-btn class="button-text secondary" height="50" width="90" large  @click="signIn" :loading="loading">
                Entrar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import routes from '../../router/routes';
export default {
  name: "LoginForm",
  data: () => ({
    email: '',
    password: undefined,
    showPassword: false,
    checkbox: false,
    loading: false,
    alert: false,
    messageError: '',
    passwordRulesValue: false
  }),
  mounted () {
    window.addEventListener('keydown', this.handleEnter)
  },
  destroyed () {
    window.removeEventListener('keydown', this.handleEnter)
  },
  created(){
    this.password = '';
  },
  watch:{
    password(value){
      this.passwordRules = this.validatePassword(value);
    }
  },
  computed:{
    emailRules(){

      if(!this.email){
        return 'Você precisa inserir seu e-mail para acessar o Infohidro.';
      }

      if(/.+@.+\..+/.test(this.email) == false){
        return 'Este e-mail é inválido.';
      }

      return true;
    },
    passwordRules:{
      set(value){

        if(value){
          this.passwordRulesValue = value;
          return;
        }

        this.passwordRulesValue = true;
      },
      get(){
        return this.passwordRulesValue;
      }
    }
  },
  methods: {
    handleEnter (e) {
      if (e.key === 'Enter') {
        this.signIn()
      }
    },
    validatePassword(value){
      !value ? 'Você precisa inserir sua senha para acessar o Infohidro.' : undefined

      if(!value){
        return 'Você precisa inserir sua senha para acessar o Infohidro.';
      }

      if(value.length < 6){
        return 'A senha deve ter pelo menos 6 caracteres.';
      }

      return true;
    },
    forgot () {
      this.$router.push(routes.login.children.forgotPassword.path);
    },
    async signIn () {
      if (this.$refs.form.validate()) {
        try{
          this.loading = true;
          await this.$store.dispatch('signIn', {email: this.email, password: this.password});
          this.$gtag.event('signIn', { method: 'Google' })
        }catch(error){
          //TODO: Handle errors
          this.passwordRules = error.message;
        }finally{
          this.loading = false;
        }
      }
    }
  }
}
</script>

<style scoped>

  label{
    order: -1;
    color: #ffffff;
  }

  .v-input:focus-within + label{
    color: var(--v-secondary-lighten1);
  }

  .form-input-group{
    display: flex;
    flex-direction: column;
  }

  .form-input-group /deep/ .v-input__icon--append .v-icon{
    color: #52B347 !important;
  }

 /*  .v-text-field--outlined /deep/ .v-input__control /deep/ .v-input__slot {
      background: #ffffff !important;
  } */

  /*  .v-text-field--outlined::v-deep .v-input__control::v-deep .v-input__slot {
      background: #ffffff !important;
  } */

</style>
